import { useEffect } from "react";

import { useSearchParams } from "src/router";
import { getCurrentScope } from "src/lib/monitoring";
import {
  SENTRY_QUERY_PARAM_TAG_PREFIX,
  SENTRY_QUERY_PARAMS_ALLOWLIST,
} from "./router-types";

/**
 * Hook to forward allowlisted query params to Sentry as namespaced tags.
 * Tags are written as `${SENTRY_QUERY_PARAM_TAG_PREFIX}${key}`.
 *
 * Cleans up by unsetting tags on effect cleanup.
 */
export function useSentryQueryParamTags(): void {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const currentScope = getCurrentScope();

    for (const key of SENTRY_QUERY_PARAMS_ALLOWLIST) {
      const value = searchParams.get(key);
      if (value) {
        currentScope.setTag(`${SENTRY_QUERY_PARAM_TAG_PREFIX}${key}`, value);
      } else {
        // Clear out stale values when the param is removed
        currentScope.setTag(
          `${SENTRY_QUERY_PARAM_TAG_PREFIX}${key}`,
          undefined,
        );
      }
    }

    return () => {
      const scope = getCurrentScope();
      for (const key of SENTRY_QUERY_PARAMS_ALLOWLIST) {
        scope.setTag(`${SENTRY_QUERY_PARAM_TAG_PREFIX}${key}`, undefined);
      }
    };
  }, [searchParams]);
}
